export type MenuPlaceholderProps = { children: React.ReactNode };

/**
 * Used to render loading or empty state in the menu.
 */
export function MenuPlaceholder(props: MenuPlaceholderProps) {
    return (
        <div aria-busy className="min-w-48 whitespace-nowrap p-4 text-center text-muted">
            {props.children}
        </div>
    );
}
